<!-- FileUpload.vue -->
<template>
    <div class="gene-container">
        <div class="gene-input-lines-div">
            <!-- <button @click="openFileSelection" class="upload_button">{{ buttonText }}</button> -->
            <textarea
              class="multilineInput"
              v-model="textInput"
              rows="5"
              placeholder="Enter genes here, one per line"
            ></textarea>
            <div>
            <div class="toggle-div">
              <label class="toggle">
                
                
                <span class="toggle-label">Scale</span>
                
                <input class="toggle-checkbox" v-model="scale_flag" type="checkbox" unchecked>
                <div class="toggle-switch"></div>
              </label>
            </div>
            <button @click="run_with_xlsx" class="round-button" :disabled="textInput === ''"> Run </button>
          </div>
        </div>
        <!-- <button @click="download_demo_xlsx" class="demo-button" id="demo_download_button"></button> -->

    </div>
    <div class="image-container">
      <!-- add an download icon-->
      <div id="wrap">
        <a @click="downloadImage" class="btn-slide">
          <span class="circle">
            <i class="fa fa-download"></i>
          </span>
          <span class="title">Download</span>
          <span class="title-hover">Click here</span>
        </a>
      </div>
        <div class="loading-spinner" v-if="loading"></div>
        <img v-else-if="image" :src="image" alt="Gene Image" class="image"/>

    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import { backendIP } from '@/config.js'
  export default {
    name: 'FileUpload',
    props: {
    uniqueId: String, // Add a unique identifier prop
    function_name: String, // Add a unique identifier prop
    sample_choose: Array,
    },
    data() {
        return {
        image: null,
        loading: false,
        selectedFile: null,
        fileName: null,
        buttonText: "Select xlsx File",
        scale_flag: false,
        textInput: "",
        };
    },
    methods: {
      // async openFileSelection() {
      //   // Open a new window or tab for file selection
      //   const fileInput = document.createElement("input");
      //   fileInput.type = "file";
      //   fileInput.accept = ".xlsx"; // Specify accepted file types if needed
      //   fileInput.addEventListener("change", this.handleFileSelection);
      //   fileInput.click();
      // },
    // async handleFileSelection(event) {
    //     const selectedFile = event.target.files[0];
    //     if (selectedFile) {
    //       // Handle the selected file (e.g., upload it to the server)
    //       // You can use Axios or another method to upload the file
    //       try {
    //     //
    //     const formData = new FormData();
    //     formData.append("file", selectedFile);
    //     const response = await axios.post(`${backendIP}/upload_xlsx`, formData);
    //     const fileName = response.data.filename;
    //     this.fileName = fileName;
    //     console.log(fileName);
    //     this.buttonText = selectedFile.name;
    //     // Do something with the file path or uniqueId
    //   } catch (error) {
    //     console.error("Error uploading file:", error);
    //   }

    //     }
    //   },
    run_with_xlsx(){
        console.log("run_with_xlsx")
        console.log("scale_flag")
        console.log(this.scale_flag)

        this.image = null;
        
        if(this.sample_choose.length == 0)
        {
          alert("Please choose at least one sample");
          return;
        }
        this.loading = true;
            

        console.log(this.sample_choose)

        var genechoose_list = this.textInput.split("\n")

        axios.post(`${backendIP}/${this.function_name}`, {samplechoose: this.sample_choose, genechoose_list: genechoose_list, scale_flag: this.scale_flag}, { responseType: 'arraybuffer' })
        .then((response) => {
          // Handle the response, which contains the image data
            this.loading = false;
            if (response.headers['content-type'] != "image/png") {
            console.error('POST request error', response);
            this.image = require('../assets/fail.png');
            return;
          }
          const imageBase64 = btoa(
            new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
          );
          this.image = `data:image/png;base64,${imageBase64}`;
          console.log("set success")
        })
        .catch((error) => {
          // Handle errors, e.g., display an error message
          console.error('POST request error', error);
          this.loading = false;
        });

    },
    downloadImage(){
        // Use the browser's download functionality, https://stackoverflow.com/a/23797348
        // only can download image when this.image is not null
        if (this.image == null) {
            return;
        }
        const link = document.createElement('a');
        link.href = this.image;
        link.download = 'figure.png';
        link.click();
    },
    // async download_demo_xlsx(){
    //   //download a local xlsx file directly

      
    //   console.log("download_demo_xlsx")
    //   const link = document.createElement('a');

    //   await axios.get(`${backendIP}/download_local_xlsx/demo.xlsx`, { responseType: 'arraybuffer' })
    //   .then((response) => {
    //     // Handle the response, which contains the xlsx data
    //     const xlsxBase64 = btoa(
    //       new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
    //     );
    //     const xlsx = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${xlsxBase64}`;
    //     link.href = xlsx;
    //     link.download = 'demo.xlsx';
    //     link.click();
    //   })
    //   .catch((error) => {
    //     // Handle errors, e.g., display an error message
    //     console.error('GET request error', error);
    //   });

    // },
  },
  };
  </script>

<style>
/* .upload_button{
  display: inline-block;
  background-color: #0099cc;
  color: white;
  padding: 0.5rem;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
  margin-top: 1rem;
} */

/* Button Style */

.gene-input-lines-div {
  margin-top: 45px;
    position: absolute;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 310px;
}
.multilineInput {
  width: 300px;
  /* padding: 10px; */
  margin-top: 20px;
  margin-bottom: 10px;
  border: 1px solid #0099cc;
  border-radius: 4px;
  font-size: 18px;
  font: bold;
}

.upload_button {
  display: inline-block;
  padding: 10px 20px;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  border-radius: 4px;
  color: #ffffff;
  background-color: #0099cc;
  border: 2px solid #0099cc;
  transition: background-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
}

/* Button Hover State */
.upload_button:hover {
  background-color: #038ebc;
  border-color: #038ebc;
}

/* Button Active State */
.upload_button:active {
  background-color: #0099cc;
  border-color: #0099cc;
}

/* Button Focus State */
.upload_button:focus {
  outline: none;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
}

/* Round Button Style */
.round-button {
  display: inline-block;
  width: 38px; /* Adjust the width and height to control the button size */
  height: 38px;
  padding: 0px;
  border-radius: 50%; /* Makes the button round */
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  color: #ffffff;
  background-color: #0099cc; /* Deep blue background color */
  border: 2px solid #0099cc; /* Deep blue border color */
  line-height: 34px; /* Vertically centers text */
  transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
  margin-left: 170px;
}

/* Round Button Hover State */
.round-button:hover {
  background-color: #038ebc; /* Darker blue on hover */
  border-color: #038ebc;
}

/* Round Button Active State */
.round-button:active {
  background-color: #0099cc; /* Even darker blue on click */
  border-color: #0099cc;
}

/* Round Button Focus State */
.round-button:focus {
  outline: none;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
}

.round-button[disabled]{
    background-color: #cccccc;
    border-color: #cccccc;
    cursor: not-allowed;
}

/* Toggle Switch Style */
.toggle {
  cursor: pointer;
  display: inline-block;
}

.toggle-switch {
  display: inline-block;
  background: #ccc;
  border-radius: 16px;
  width: 50px;
  height: 32px;
  margin-left: 5px;
  position: relative;
  vertical-align: middle;
  transition: background 0.25s;
}
.toggle-switch:before, .toggle-switch:after {
  content: "";
}
.toggle-switch:before {
  display: block;
  background: linear-gradient(to bottom, #fff 0%, #eee 100%);
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
  width: 24px;
  height: 24px;
  position: absolute;
  top: 4px;
  left: 4px;
  transition: left 0.25s;
}
.toggle:hover .toggle-switch:before {
  background: linear-gradient(to bottom, #fff 0%, #fff 100%);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
}
.toggle-checkbox:checked + .toggle-switch {
  background: #56c080;
}
.toggle-checkbox:checked + .toggle-switch:before {
  left: 22px;
}

.toggle-checkbox {
  position: absolute;
  visibility: hidden;
}

.toggle-label {
  margin-left: 5px;
  position: relative;
  top: 0px;
  font-size: 10px;
  font-weight: bold;
  display: inline-block;
  height: 14px;
}

.toggle-div{
  display: inline-block;
  /* margin-left: 15px; */
  background-color: #0099cc;
  border: 2px solid #0099cc;
  transition: background-color 0.3s ease, color 0.3s ease;
  border-radius: 4px;
  color: #ffffff;
  font-size: 10px;
  font-weight: bold;
  padding: 1px 4px;
  position: relative;
  top: -1px;
  left: 163px;
  /* height:34px; */
}

.demo-button{
  position: absolute;
  display: inline-block;
  width: 38px; /* Adjust the width and height to control the button size */
  height: 38px;
  padding: 0px;
  right: 0px;
  border-radius: 50%; /* Makes the button round */
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  color: #ffffff;
  background-color: #0099cc; /* Deep blue background color */
  border: 2px solid #0099cc; /* Deep blue border color */
  line-height: 34px; /* Vertically centers text */
  transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
}

.demo-button:hover {
  /* content: 'test'; */
  background-color: white; /* Darker blue on hover */
  border-color: #0099cc;
  color: #0099cc;
  /*change text to &#9660*/

}

.demo-button::after{
  content: "Demo";
}

.demo-button:hover::after{
  content: '▼';
}
</style>
  